<template>
  <div>
    <PromptControl
      @ok="ok"
      @cancel="cancel"
      @closed="closed"
      v-bind:show="prompt"
      v-bind:title="lang('lbl_0000113')"
      v-bind:message="lang('lbl_0000122')"
    />
    <ModalControl
      @closed="modalClosed"
      v-bind:show="modal"
      v-bind:title="lang('lbl_0000155')"
      dismiss
    >
    </ModalControl>
    <ContentWrapperControl class="mt-4">
      <SliderControl :slides="getSlides"></SliderControl>
      <div
        v-if="this.election.code == 'GA00000003'"
        class="overflow-hidden bg-white rounded-lg shadow mt-4"
      >
        <div class="bg-white p-4 -mt-1 rounded-lg">
          <div class="border-l-4 border-secondary pl-3 flex flex-col mt-3 mb-4">
            <span class="font-semibold text-sm">44th GENERAL ASSEMBLY</span>
            <span class="text-xs"
              >Philippine Army Headquarters, Taguig City</span
            >
          </div>
          <div
            v-if="
              countdownDate ||
              (!getElectionUser.can_participate &&
                getSchedules.registration_ended)
            "
          >
            <div
              class="uppercase italic font-bold text-primary text-center text-sm mt-3 mb-3"
            >
              {{ countdownLabel }}
            </div>

            <SpecialCountdownControl :compressed="true" :date="countdownDate" />
          </div>
          <div
            v-if="
              !isActionButtonVisible &&
              ((getSchedules.registration_ended &&
                getElectionUser.can_participate &&
                getSchedules.voting_started &&
                !getElectionUser.has_registered) ||
                getSchedules.voting_ended)
            "
            class="line-container"
          >
            <hr />
          </div>
          <div
            v-if="
              getSchedules.registration_ended &&
              getElectionUser.can_participate &&
              getSchedules.voting_started &&
              !getElectionUser.has_registered
            "
            class="mt-3 text-center text-sm font-semibold text-red-600"
          >
            Registration has ended.
          </div>
          <div
            v-if="getSchedules.voting_ended"
            class="mt-3 text-center text-sm font-semibold text-red-600"
          >
            Voting has ended.
          </div>
          <div class="mt-3">
            <!-- Already voted -->
            <ButtonControl
              v-if="
                getElectionUser.has_participated &&
                getSchedules.voting_started &&
                !getSchedules.voting_ended
              "
              class="w-full"
              :disabled="true"
            >
              {{ lang("lbl_0000375") }}
            </ButtonControl>

            <!-- Vote Now -->
            <ButtonControl
              v-if="
                getElectionUser.has_registered &&
                getElectionUser.can_participate &&
                !getElectionUser.has_participated &&
                getSchedules.voting_started &&
                !getSchedules.voting_ended
              "
              class="w-full"
              @click="$router.push('/ga/policy')"
            >
              {{ lang("lbl_0000121") }}
            </ButtonControl>

            <!-- Already Registered -->
            <ButtonControl
              v-if="
                getElectionUser.has_registered &&
                !(
                  getElectionUser.can_participate && getSchedules.voting_started
                )
              "
              class="w-full"
              disabled
            >
              {{ lang("lbl_0000352") }}
            </ButtonControl>

            <!-- Register -->
            <ButtonControl
              v-else-if="
                getSchedules.registration_started &&
                !getElectionUser.has_registered &&
                !getSchedules.registration_ended
              "
              class="w-full"
              @click="register"
            >
              {{ lang("lbl_0000113") }}
            </ButtonControl>

            <!-- Not yet started -->
            <ButtonControl
              v-else-if="!getSchedules.registration_started"
              class="w-full"
            >
              {{ lang("lbl_0000382") }}
            </ButtonControl>
          </div>
        </div>
      </div>
    </ContentWrapperControl>
    <ModalControl
      @closed="show_rating = false"
      :dismiss="true"
      :show="show_rating"
      :title="lang('lbl_0000226')"
    >
      <div class="flex flex-col">
        <span class="mt-2">{{ lang("lbl_0000218") }}</span>
        <div class="flex flex-col items-center mt-4">
          <SpecialRatingControl v-bind:submit="submit_rating" :type="1" />
        </div>
        <div class="flex flex-row mt-4">
          <ButtonControl
            :theme="'error'"
            @click="
              show_rating = false;
              this.$router.push({ name: 'dashboard-page' });
            "
            class="mr-4"
          >
            {{ lang("lbl_0000199") }}
          </ButtonControl>
          <ButtonControl @click="submitRating()">
            {{ lang("lbl_0000190") }}
          </ButtonControl>
        </div>
      </div>
    </ModalControl>
    <ModalControl
      @closed="show_success = false"
      :dismiss="false"
      :show="show_success"
      :title="lang('lbl_0000225')"
      theme="success"
    >
      <div>
        <img
          src="@/assets/icons/papsi_check_circle.svg"
          class="block mx-auto mt-2 h-modal-icon w-modal-icon"
        />
        <div
          v-text="lang('lbl_0000290')"
          class="text-sm text-center pt-5 pb-5 font-semibold"
        ></div>
        <ButtonControl
          @click="
            show_rating = true;
            show_success = false;
          "
        >
          {{ lang("lbl_0000015") }}
        </ButtonControl>
      </div>
    </ModalControl>
  </div>
</template>

<script>
import datetime from "date-and-time";
import ContentWrapperControl from "./../components/controls/ContentWrapperControl.vue";
import SpecialCountdownControl from "@/components/controls/SpecialCountdownControl.vue";
import SpecialRatingControl from "@/components/controls/SpecialRatingControl.vue";
import SliderControl from "@/components/controls/SliderControl.vue";
import ButtonControl from "./../components/controls/ButtonControl.vue";
import PromptControl from "./../components/controls/PromptControl.vue";
import ModalControl from "./../components/controls/ModalControl.vue";
import FunRun from "@/services/FunRun";
import GA from "../services/GA.js";
import mixin from "./../mixin.js";

export default {
  mixins: [mixin],
  components: {
    ContentWrapperControl,
    SpecialCountdownControl,
    SpecialRatingControl,
    ButtonControl,
    ModalControl,
    PromptControl,
    SliderControl,
  },
  data() {
    return {
      image: "",
      loading: true,
      registration_started: false,
      voting_started: false,
      voting_ended: false,
      title: null,
      message: "",
      voted: false,
      registered: false,
      can_vote: false,
      prompt: false,
      modal: false,
      show_rating: false,
      submit_rating: false,
      show_success: false,
      code: null,
      sga: {
        date: null,
        title: null,
        user: {
          uuid: null,
          can_participate: false,
          has_participated: false,
        },
        schedules: {
          has_started: false,
          has_ended: false,
          start_date: null,
          end_date: null,
        },
      },
      fun_run: {
        run_key: null,
        run_year: null,
        event_name: null,
        event_date: null,
        event_location: null,
        has_started: false,
        has_ended: false,
        registration_start: null,
        registration_end: null,
      },
      election: {
        enabled: process.env.VUE_APP_ELECTION_ENABLED.toString() == "true",
        code: null,
        title: null,
        date: null,
        user: {
          can_participate: null,
          has_participated: null,
          has_registered: null,
        },
        test_user: {
          can_participate: true,
          has_participated: false,
          has_registered: false,
          enabled: false,
        },
        schedules: {
          registration_start: null,
          registration_started: null,
          registration_end: null,
          registration_ended: null,
          voting_start: null,
          voting_started: null,
          voting_end: null,
          voting_ended: null,
        },
        test_schedules: {
          registration_start: "2026-02-01 00:00:00",
          registration_started: true,
          registration_end: "2026-02-24 00:00:00",
          registration_ended: false,
          voting_start: "2026-02-22 10:30:00",
          voting_started: true,
          voting_end: "2026-03-25 14:00:00",
          voting_ended: false,
          enabled: false,
        },
      },
    };
  },
  mounted() {
    this.$emit("checkauth");
    this.$emit("nofooter", false);
    this.$emit("shownavbar", {
      type: "primary",
    });

    this.image = this.getMediaPath("/ad/ga25_banner_sm.jpg");

    let state = this.$store.state;

    if (
      (!state.info.tin || !state.info.date_of_birth) &&
      this.$cookies.get("skipped_update") !== state.hash
    ) {
      this.makeSkipCookie(state.hash);
      this.$router.push("/user/info/checklist/optional");
      return;
    }

    if (!state.deactivated && state.has_pin && this.code == "GA00000002") {
      this.loadSGA();
      return;
    }

    if (!state.deactivated && state.has_pin && this.election.enabled) {
      this.loadGA();
      return;
    }
  },
  computed: {
    getElectionUser() {
      const u = this.election.user;
      const t = this.election.test_user;

      if (!t.enabled) return u;

      return {
        can_participate: t.can_participate ?? u.can_participate,
        has_participated: t.has_participated ?? u.has_participated,
        has_registered: t.has_registered ?? u.has_registered,
      };
    },
    countdownDate() {
      const s = this.getSchedules;
      const u = this.getElectionUser;

      if (!s) return null;

      if (
        !u.has_registered &&
        s.registration_started &&
        !s.registration_ended
      ) {
        return s.registration_end;
      }

      if (u.has_registered && u.can_participate) {
        if (!s.voting_started && s.voting_start) return s.voting_start;
        if (s.voting_started && !s.voting_ended) return s.voting_end;
      }

      if (!u.can_participate) {
        if (s.registration_started && !s.registration_ended)
          return s.registration_end;
        if (!s.registration_started && s.registration_start)
          return s.registration_start;
        if (s.registration_ended) return s.registration_end;
      }

      return null;
    },

    countdownLabel() {
      const s = this.getSchedules;
      const u = this.getElectionUser;

      if (!s) return "";

      if (!u.has_registered) {
        if (!s.registration_started) return "Registration starts in";
        if (s.registration_started && !s.registration_ended)
          return "Registration ends in";
        if (s.registration_ended) return "Registration has ended";
      }

      if (u.has_registered && u.can_participate) {
        if (!s.voting_started) return "Voting starts in";
        if (s.voting_started && !s.voting_ended) return "Voting ends in";
        if (s.voting_ended) return "Voting has ended";
      }

      if (!u.can_participate) {
        if (!s.registration_started) return "Registration starts in";
        if (s.registration_started && !s.registration_ended)
          return "Registration ends in";
        if (s.registration_ended) return "Registration has ended";
      }

      return "";
    },
    getSlides() {
      return [
        {
          background_image: this.getBackgroundImage(
            "eft/",
            "papsi_eft_banner.jpg",
          ),
          title: this.lang("lbl_0000297"),
          subtitle: "",
          button_text: this.lang("lbl_0000309"),
          button_link: "/services/eft",
          button_disabled: false,
          button_style: "primary",
        },
        {
          background_image: this.getBackgroundImage(
            "ga/",
            "papsi_election.jpg",
          ),
          title:
            this.setTitleText(this.election.title) ?? this.lang("lbl_0000353"),
          subtitle: "",
          button_text: this.lang("lbl_0000354"),
          button_link: "/events",
          button_disabled: false,
          button_style: "primary",
        },
      ];
    },
    getSchedules() {
      const s = this.election.schedules;
      const t = this.election.test_schedules;

      if (!t.enabled) return s;

      const reg_start = t.registration_start ?? s.registration_start;
      const reg_end = t.registration_end ?? s.registration_end;
      const vote_start = t.voting_start ?? s.voting_start;
      const vote_end = t.voting_end ?? s.voting_end;

      return {
        registration_start: reg_start,
        registration_end: reg_end,
        voting_start: vote_start,
        voting_end: vote_end,

        registration_started: this.hasStarted(reg_start),
        registration_ended: this.hasEnded(reg_end),

        voting_started: this.hasStarted(vote_start),
        voting_ended: this.hasEnded(vote_end),
      };
    },
    isActionButtonVisible() {
      const u = this.getElectionUser;
      const s = this.getSchedules;

      if (s.voting_ended) return false;

      if (
        u.has_registered &&
        u.can_participate &&
        s.voting_started &&
        !s.voting_ended
      )
        return true;

      if (u.has_registered) return true;

      if (!u.has_registered && !s.registration_ended) return true;

      return false;
    },
  },
  methods: {
    hasStarted(date) {
      if (!date) return false;
      return new Date() >= new Date(date);
    },

    hasEnded(date) {
      if (!date) return false;
      return new Date() >= new Date(date);
    },
    register() {
      this.$emit("showloader");

      GA.register(this.election.code, this.$store.state.info.hash)
        .then((response) => {
          if (response.status === 200) {
            this.$emit("success", response.data.data.message);
            this.$store.state.ga.user.has_registered = true;
            this.election.user.has_registered = true;
          }
        })
        .catch((error) => {
          this.$emit("error", error);
        })
        .finally(() => this.$emit("hideloader"));
    },
    getBackgroundImage(path, file_name) {
      if (process.env.VUE_APP_CDN_URL) {
        return process.env.VUE_APP_CDN_URL + path + file_name;
      }
    },
    tick(start, end) {
      // const now = new Date().getTime();
      // const start_time = new Date(start).getTime();
      // const end_time = new Date(end).getTime();
      // const store_fun_run = this.$store.state.fun_run;
      // const local_fun_run = this.fun_run;

      // if (now >= end_time) {
      //   store_fun_run.has_started = true;
      //   store_fun_run.has_ended = true;
      //   local_fun_run.has_started = true;
      //   local_fun_run.has_ended = true;
      //   return;
      // } else if (now >= start_time && now < end_time) {
      //   store_fun_run.has_started = true;
      //   store_fun_run.has_ended = false;
      //   local_fun_run.has_started = true;
      //   local_fun_run.has_ended = false;
      // } else {
      //   store_fun_run.has_started = false;
      //   store_fun_run.has_ended = false;
      //   local_fun_run.has_started = false;
      //   local_fun_run.has_ended = false;
      // }
      const now = new Date().getTime();
      const store_election = this.$store.state.election;
      const local_election = this.election;
      const schedules = local_election.schedules;

      const reg_start = schedules.registration_start
        ? new Date(schedules.registration_start).getTime()
        : null;

      const reg_end = schedules.registration_end
        ? new Date(schedules.registration_end).getTime()
        : null;

      const vote_start = schedules.voting_start
        ? new Date(schedules.voting_start).getTime()
        : null;

      const vote_end = schedules.voting_end
        ? new Date(schedules.voting_end).getTime()
        : null;

      if (reg_start && reg_end) {
        if (now >= reg_end) {
          schedules.registration_started = true;
          schedules.registration_ended = true;
        } else if (now >= reg_start) {
          schedules.registration_started = true;
          schedules.registration_ended = false;
        } else {
          schedules.registration_started = false;
          schedules.registration_ended = false;
        }
      }

      if (vote_start && vote_end) {
        if (now >= vote_end) {
          schedules.voting_started = true;
          schedules.voting_ended = true;
        } else if (now >= vote_start) {
          schedules.voting_started = true;
          schedules.voting_ended = false;
        } else {
          schedules.voting_started = false;
          schedules.voting_ended = false;
        }
      }

      store_election.schedules = { ...schedules };

      setTimeout(() => this.tick(start, end), 1000);
    },
    isButtonVisible() {
      return (
        !this.voting_ended &&
        ((this.voting_started && !this.voted && this.can_vote) ||
          (this.registration_started && !this.registered))
      );
    },
    loadFunRun() {
      this.$emit("showloader");
      FunRun.getSchedule()
        .then((response) => {
          const data = response.data.data;

          if (!Array.isArray(data) || data.length === 0) {
            console.warn("No schedule data found");
            return;
          }

          const event = data[0];
          const state = this.$store.state.fun_run;
          state.run_key = event.run_key;
          state.run_year = event.run_year;
          state.event_name = event.event_name;
          state.event_date = event.event_date;
          state.event_location = event.event_location;
          state.has_started = event.has_started;
          state.has_ended = event.has_ended;
          state.registration_start = event.registration_start;
          state.registration_end = event.registration_end;

          this.fun_run = { ...state };
          this.tick(state.registration_start, state.registration_end);
        })
        .catch((error) => {
          this.loading = false;
          this.$emit("error", error);
        })
        .finally(() => {
          this.$emit("hideloader");
        });
    },
    loadSGA() {
      GA.special()
        .then((response) => {
          let data = response.data.data,
            state = this.$store.state.sga;
          state.code = data.code;
          state.date = data.date;
          state.title = data.title;
          state.user.uuid = data.user.uuid;
          state.user.can_participate = data.user.can_participate;
          state.user.has_participated = data.user.has_participated;
          state.schedules.has_started = data.schedules.has_started;
          state.schedules.has_ended = data.schedules.has_ended;
          state.schedules.start_date = data.schedules.start_date;
          state.schedules.end_date = data.schedules.end_date;

          this.code = data.code;
          this.sga.title = data.title;
          this.sga.date = data.date;
          this.sga.user.uuid = data.user.uuid;
          this.sga.user.can_participate = data.user.can_participate;
          this.sga.user.has_participated = data.user.has_participated;
          this.sga.user.has_registered = data.user.has_registered;
          this.sga.schedules.has_started = data.schedules.has_started;
          this.sga.schedules.has_ended = data.schedules.has_ended;
          this.sga.schedules.start_date = data.schedules.start_date;
          this.sga.schedules.end_date = data.schedules.end_date;
          // this.tick();
          this.tick(this.sga.schedules.start_date, this.sga.schedules.end_date);
          this.loading = false;
        })
        .catch((error) => {
          this.loading = false;
          this.$emit("error", error);
        });
    },
    loadGA() {
      this.$emit("showloader");

      GA.getCurrentElection()
        .then((response) => {
          if (response.status === 200) {
            const data = response.data.data;
            const schedules = data.schedules || {};

            this.$store.state.ga.code = data.code;
            this.$store.state.ga.title = data.title;
            this.$store.state.ga.date = data.date;

            this.$store.state.ga.registration.start_date =
              schedules.registration_start;
            this.$store.state.ga.registration.started =
              schedules.registration_started ?? false;
            this.$store.state.ga.registration.end_date =
              schedules.registration_end;
            this.$store.state.ga.registration.ended =
              schedules.registration_ended ?? false;

            this.$store.state.ga.voting.start_date = schedules.voting_start;
            this.$store.state.ga.voting.started =
              schedules.voting_started ?? false;
            this.$store.state.ga.voting.end_date = schedules.voting_end;
            this.$store.state.ga.voting.ended = schedules.voting_ended ?? false;

            this.election.code = data.code;
            this.election.title = data.title;
            this.election.date = data.date;

            this.election.schedules.registration_start =
              schedules.registration_start;
            this.election.schedules.registration_started =
              schedules.registration_started ?? false;
            this.election.schedules.registration_end =
              schedules.registration_end;
            this.election.schedules.registration_ended =
              schedules.registration_ended ?? false;

            this.election.schedules.voting_start = schedules.voting_start;
            this.election.schedules.voting_started =
              schedules.voting_started ?? false;
            this.election.schedules.voting_end = schedules.voting_end;
            this.election.schedules.voting_ended =
              schedules.voting_ended ?? false;

            this.election.user.has_participated =
              this.$store.state.ga.user.has_participated;
            this.election.user.has_registered =
              this.$store.state.ga.user.has_registered;
            this.election.user.can_participate =
              this.$store.state.ga.user.can_participate;
          }
        })
        .catch((error) => {
          this.$emit("error", error);
        })
        .finally(() => {
          this.$emit("hideloader");
        });
    },
    ticking(message) {
      let state = this.$store.state;

      this.registration_started = state.ga.registration.started;
      this.voting_started = state.ga.voting.started;
      this.voting_ended = state.ga.voting.ended;
      this.message = message;
    },
    setVotingEnd() {
      this.voting_ended = true;
    },
    getLoader() {
      return process.env.VUE_APP_MEDIA_URL + "images/loader/gear-spinner.gif";
    },
    getButtonLabel() {
      let state = this.$store.state;

      if (this.voting_started && !state.ga.voted && state.ga.registered) {
        return this.lang("lbl_0000121");
      } else {
        return this.lang("lbl_0000113");
      }
    },
    openPrompt() {
      let state = this.$store.state;

      if (this.voting_started && !state.ga.voted && state.ga.registered) {
        this.$router.push("/ga/election/auth");
      } else {
        this.prompt = true;
      }
    },
    ok() {
      let state = this.$store.state;

      if (this.voting_started && !state.ga.voted && state.ga.registered) {
        this.vote();
      } else {
        this.register();
      }
    },
    cancel() {
      this.prompt = false;
    },
    closed() {
      this.prompt = false;
    },
    vote() {
      this.$router.push("/ga/vote");
    },
    modalOpen() {
      this.modal = true;
    },
    modalClosed() {
      this.modal = false;
    },
    formatDate(date) {
      return datetime.format(new Date(date), "MM/DD/YYYY hh:mm A");
    },
    formatSchedule(date) {
      const options = {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric",
        hour: "numeric",
        minute: "2-digit",
        hour12: true,
      };

      return new Date(date).toLocaleString("en-US", options);
    },
    registerSGA() {
      let state = this.$store.state;

      this.$emit("showloader");
      GA.register(this.code, state.hash, state.key)
        .then(() => {
          // state.sga.user.has_registered = true;
          this.sga.user.has_registered = true;
          this.show_success = true;
        })
        .catch((error) => {
          this.$emit("error", error);
        })
        .finally(() => {
          this.$emit("hideloader");
        });
    },
    submitRating() {
      this.submit_rating = true;
      this.show_rating = false;
    },
  },
};
</script>

<style scoped>
.papsi-status-dim {
  width: 10px;
  height: 10px;
}

.line-container {
  width: 100%;
  text-align: center;
  margin: 20px 0;
}

.line-container hr {
  border: 0;
  height: 1px;
  background-color: rgba(51, 51, 51, 0.3);
  width: 100%;
}
</style>
